import {
    Field,
    FormikProps
} from 'formik';
import {
    FormikRadioCardGroup,
    PlatformFieldset
} from "@flexinet/ui-components";
import {
    ApplicationAccountFormType,
    ApplicationAccountStatus
} from "../types.ts";
import {ApplicationsAutocomplete} from "../../applications/inputs/ApplicationsAutocomplete.tsx";


export const FormComponent = (props: FormikProps<ApplicationAccountFormType>) => {

    const editing = typeof props.values.id !== 'undefined';

    return (
        <>
            <PlatformFieldset legend={'Application Account Details'}>

                <Field
                    name='applicationId'
                    label='Application'
                    description='Please select application'
                    component={ApplicationsAutocomplete}
                    disabled={editing}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>


            <PlatformFieldset legend={'Status'}>

                <Field
                    name='accountApplicationStatus'
                    data={[{
                        label: ApplicationAccountStatus.ACTIVE,
                        value: ApplicationAccountStatus.ACTIVE
                    }, {
                        label: ApplicationAccountStatus.INACTIVE,
                        value: ApplicationAccountStatus.INACTIVE
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>
        </>
    );
};
